import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerAppIcons } from './app/icons';

if (environment.production) {
  enableProdMode();
}

registerAppIcons();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
